module.exports = __webpack_public_path__ + "static/img/curo-dis95.472a626b.jpg";